import { CustomDialog } from "components/dialogs/Dialogs";
import { Button, Input } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import Grid from "@mui/material/Grid2";
import { useState } from "react";
import { ShipType } from "view/shipPlanning/ShipPlanningOverview";

type UpdateShipLocationDialogProps = {
	ship: ShipType;
	open: boolean;
	loading: boolean;
	onClose: () => void;
	onUpdate: (location?: string) => void;
}

const UpdateShipLocationDialog = ({ ship, loading, open, onClose, onUpdate }: UpdateShipLocationDialogProps) => {

	const location = ship.position?.location?.trim() ?? undefined;

	const [ value, setValue ] = useState(location);

	return (
		<CustomDialog
			maxWidth="sm"
			open={open}
			onClose={onClose}
			title={intl.formatMessage({ id: "LOCATION" })}
			actions={
				<Button size="small" onClick={() => onUpdate(value)} loading={loading}>
					{intl.formatMessage({ id: "SAVE" })}
				</Button>
			}>
			<Grid container spacing={3}>
				<Grid size={12}>
					<Input
						value={value}
						onChange={ev => setValue(ev.target.value)}
						autoFocus
					/>
				</Grid>
			</Grid>
		</CustomDialog>
	);
};

export default UpdateShipLocationDialog;
